export interface IPageTagsResources {
  title: string;
  titleDescription: string;
}

export const PageTagsResources: IPageTagsResources = {
  title: "Tagi",
  titleDescription: "marki i produkty z gazetki",
};
